import FormHandler, { FormHandlerOnSubmitOptions } from '../../forms/FormHandler';
import { IRecaptchaSettings, RecaptchaService } from '../../utils/RecaptchaService';

window.tnew.page.initialize = ({ recaptchaSettings }: {
  recaptchaSettings: IRecaptchaSettings,
}) => {
  const $form = document.querySelector('#tn-account-create-brief-form') as HTMLFormElement;

  const recaptchaService = new RecaptchaService($form, recaptchaSettings);

  const onSubmit = async ({ stopSubmitting }: FormHandlerOnSubmitOptions) => {
    if (recaptchaSettings.isRecaptchaEnabled) {
      try {
        const token = await recaptchaService.challenge('signup');
        if (token === undefined) {
          stopSubmitting();
          return;
        }
      } catch (err) {
        stopSubmitting();
        return;
      }
    }

    $form.submit();
  };

  new FormHandler($form, {
    onValidationSuccess: onSubmit,
  });
};
